import { createContext, useContext } from "react";

const LiveEventsContext = createContext(null);

// Small context for the header bell, so it doesn't re-render on every event list change.
export const LiveEventsBellContext = createContext(null);

export const useLiveEventsContext = () => {
  const context = useContext(LiveEventsContext);
  if (!context) {
    throw new Error(
      "useLiveEventsContext must be used within a LiveEventsProvider",
    );
  }
  return context;
};

export const useLiveEventsBellContext = () => {
  const context = useContext(LiveEventsBellContext);
  if (!context) {
    throw new Error(
      "useLiveEventsBellContext must be used within a LiveEventsProvider",
    );
  }
  return context;
};

export default LiveEventsContext;
